const onLoadCallbackName = "onRecaptchaLoadedCallback"

class Recaptcha {
  constructor(elementId, element, siteKey = null) {
    this.elementId = elementId
    this.$element = element
    if (siteKey !== null) {
      this.siteKey = siteKey
    } else {
      this.siteKey = this.$element.dataset.sitekey
    }
    this.loaded = false
    this.languageCode = this.$element.dataset.languageCode || "en"
  }

  showOnLoad() {
    window[onLoadCallbackName] = () => this.show()
    const newScript = document.createElement("script")
    newScript.src = `https://www.google.com/recaptcha/api.js?onload=${onLoadCallbackName}&render=explicit`
    document.body.appendChild(newScript)
  }

  show() {
    if (this.loaded) {
      window.grecaptcha.reset()
    } else {
      this.renderRecaptcha()
    }
    this.$element.style.display = "block"
  }

  reset() {
    this.show()
  }

  hide() {
    this.$element.style.display = "none"
  }

  data() {
    return {
      "g-recaptcha-response": this.getResponse(),
      recaptcha_site_key: this.siteKey,
      recaptcha_version: "2",
    }
  }

  renderRecaptcha() {
    if (typeof grecaptcha !== "undefined") {
      // work-around issue with recaptcha loading on firefox
      // there seems to be a race condition on loading this - so give it some extra time if it
      // hasn't loaded yet. Thanks to Pat McKenna for this work-around.
      if (typeof window.grecaptcha.render === "undefined") {
        window.setTimeout(this.renderRecaptcha, 500)
        return
      }
      this.recaptchaInstance = window.grecaptcha.render(this.elementId, {
        sitekey: this.siteKey,
        hl: this.languageCode,
      })
      this.loaded = true
    } else {
      this.showOnLoad()
    }
  }

  getResponse() {
    return window.grecaptcha.getResponse(this.recaptchaInstance)
  }
}

export default Recaptcha
